import axios from "axios";
import { Store, useStore } from "vuex";
import { auth } from "../store/modules/auth.store";
import { addRequestHeaderData, addSidToRequestHeaderData, addSidToRequestURL } from "./helpers/api.helper";

const ApiService = {
  init(baseURL: string | undefined, store: any) {
    //const store = useStore();
    axios.defaults.baseURL = baseURL;

    // Add a request interceptor
    axios.interceptors.request.use(
      function (request: any) {
        const { appSessionKey, token, type } = auth.state;

        if (type === 'OKTA' && request.method !== 'options') {
          request.headers["Authorization"] = "Okta " + token;
          request.headers["Content-Type"] = "application/json";
          request.headers["X-Requested-App"] = "organisation";
          request.headers["X-Requested-App-User"] = appSessionKey;
        }

        // add data and body to put and post requests if they require it
        if (request.method === "put" || request.method === "post") {
          const { command } = request.data;
          if (command) {
            const { command } = request.data;
            const { body } = request.data;
            request.data.head = addRequestHeaderData(request.data.head, command);
            if (type === 'PMX') {
              request.data.head.appSessionKey = appSessionKey;
              request.data.head.uuid = token;
            }
            request.body = body;
          } else {
            if (type === 'PMX') {
              request.data = addSidToRequestHeaderData(request.data, appSessionKey, token);
            }
          }
        }

        // add session id to get requests
        if (request.method === "get" && type === 'PMX') {
          request.url = addSidToRequestURL(request.url, appSessionKey, token);
        }

        return request;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        //console.log("response: ", JSON.stringify(response, null, 4));
        if (response.status === 200 || response.status === 201) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(response);
        }
      },
      (error) => {
        if (error.response) {
          if (error.response.status) {
            let loginRedirect;
            switch (error.response.status) {
              case 401:
                if (window.location.hostname.includes("localhost")) {
                  loginRedirect = window.location.protocol + "//" + window.location.host + "/login";
                } else {
                  loginRedirect = window.location.protocol + "//" + window.location.host + "/#core/login";
                }
                window.location.href = loginRedirect;
                break;
              case 404:
                store.dispatch("application/setError", {
                  title: "Page Not Found",
                  message: "The page could not be found",
                });
                break;
              case 422:
                return Promise.reject(error.response.data.error);
              case 500:
                store.dispatch("application/setError", {
                  title: "Server Error",
                  message: "A server error occured",
                });
                break;
            }
          }
        } else if (error.request) {
          // The request was made but no response was received
          // console.log("NO SERVER RESPONSE RECEIVED");
          // console.log("error.request: ", error.request);
          store.dispatch("application/setError", {
            title: "Server Did Not Respond",
            message: "The server did not respond",
          });
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log("ERROR SETTING UP REQUEST");
          // console.log("error.message: ", error.message);
          store.dispatch("application/setError", {
            title: "An Error Occured",
            message: "An Error Occured",
          });
        }
        return Promise.reject(error);
      }
    );
  },

  get(resource: string) {
    return axios.get(resource);
  },

  post(resource: string, data: any) {
    return axios.post(resource, data);
  },

  put(resource: string, data: any) {
    return axios.put(resource, data);
  },

  delete(resource: string) {
    return axios.delete(resource);
  },
};

export default ApiService;
